import { cb } from 'cb-utils/cbLib';
import { QueryObj } from 'clearblade-js-client';
import { difference, without } from 'lodash';

export interface FetchQueryParms {
  isFiltered?: boolean;
  query: QueryObj;
  systemKey?: string;
  collectionName?: string;
}

export const createCountQuery = (): QueryObj => {
  return cb.Query().setPage(0, 0);
};

export interface CBDiff {
  add?: string[];
  remove?: string[];
}

export function getArrayDiff(startArr: string[], endArr: string[]): CBDiff {
  const endArrStripped = without(endArr, null);
  const startArrStripped = without(startArr, null);
  const add = difference(endArrStripped, startArrStripped);
  const remove = difference(startArrStripped, endArrStripped);
  const result: CBDiff = {};
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (add) result.add = add;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (remove) result.remove = remove;
  return result;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function applyDiff(arr: any[], diff: CBDiff) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const withDeleted = difference(arr, diff.remove);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return [...withDeleted, ...diff.add];
}
